import { SessionStorageService } from 'ngx-webstorage';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { FormService } from './form.service';
import { SharedService } from './shared.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, finalize, tap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { ProposalService } from './proposal.service';
import { LocalStorageService } from 'ngx-localstorage';
import { NormalizeUrlService } from '@allianz/ngx-aem-integration';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { KpiEnum } from '../interfaces/kpi.enum';

@Injectable({
  providedIn: 'root',
})
export class OfferService {

  savedOfferId: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private sharedService: SharedService,
    private formService: FormService,
    private translateService: TranslateService,
    private localStorage: LocalStorageService,
    private proposalService: ProposalService,
    private sessionService: SessionStorageService,
    private storage: LocalStorageService
  ) {
    this.sharedService.isOfferFromEmail =
      this.sessionService.retrieve('isOfferFromEmail');
  }

  public saveOffer(
    calculatedPremiums,
    productProposals,
    selectedItem,
    callback
  ) {
    let currentFormData = this.formService.currentForm.getRawValue();

    let offerPayload = {
      n_1NSP_Premium: calculatedPremiums.n_1NSP_Premium,
      n_2NSP_Premium: calculatedPremiums.n_2NSP_Premium,
      n_3NSP_Premium: calculatedPremiums.n_3NSP_Premium,
      n_1NSP_PremiumCurr2 : calculatedPremiums.n_1NSP_PremiumCurr2 ,
      n_2NSP_PremiumCurr2 : calculatedPremiums. n_2NSP_PremiumCurr2,
      n_3NSP_PremiumCurr2 : calculatedPremiums. n_3NSP_PremiumCurr2,
      chosenPremiumSaveOffer: currentFormData.chosenPremiumSaveOffer,
      chosenPremiumSaveOfferCurr2: currentFormData.chosenPremiumSaveOfferCurr2,
      cityName: currentFormData?.cityName,
      purpose: calculatedPremiums.purpose,
      yearOfConstruction: calculatedPremiums.yearOfConstruction,
      street: currentFormData.street,
      claimsExists: calculatedPremiums.claimsExists,
      recommendedPackage: calculatedPremiums.recommendedPackage,
      discount1: calculatedPremiums.discount1,
      nErr_Code: calculatedPremiums.nErr_Code,
      status: calculatedPremiums.status,
      contractProcessState: calculatedPremiums.contractProcessState,
      currency: calculatedPremiums.currency,
      doubleVisualization: currentFormData.doubleVisualization,
      propertyCategory: calculatedPremiums.propertyCategory,
      propertySubcategory: calculatedPremiums.propertySubcategory,
      postCode: calculatedPremiums.postCode,
      area: calculatedPremiums.area,
      insSumOutsideObjects: calculatedPremiums.insSumOutsideObjects,
      insSumSpecificObjects: calculatedPremiums.insSumSpecificObjects,
      isEarthQuakeIncluded: calculatedPremiums.isEarthQuakeIncluded,
      isGlassIncluded: calculatedPremiums.isGlassIncluded,
      isGoMaxIncluded: calculatedPremiums.isGoMaxIncluded,
      isDeductibleIncluded: calculatedPremiums.isDeductibleIncluded,
      isRenewed: calculatedPremiums.isRenewed,
      commissionDiscount: calculatedPremiums.commissionDiscount,
      immovableinsuranceSumRecommended:
        calculatedPremiums.immovableinsuranceSumRecommended,
      movableinsuranceSumRecommended:
        calculatedPremiums.movableinsuranceSumRecommended,
      topComfort: calculatedPremiums.topComfort,
      topExtra: calculatedPremiums.topExtra,
      topMax: calculatedPremiums.topMax,
      bottomComfortOne: calculatedPremiums.bottomComfortOne,
      bottomExtraOne: calculatedPremiums.bottomExtraOne,
      bottomMaxOne: calculatedPremiums.bottomMaxOne,
      bottomComfortTwo: calculatedPremiums.bottomComfortTwo,
      bottomExtraTwo: calculatedPremiums.bottomExtraTwo,
      bottomMaxTwo: calculatedPremiums.bottomMaxTwo,
      bottomComfortFour: calculatedPremiums.bottomComfortFour,
      bottomExtraFour: calculatedPremiums.bottomExtraFour,
      bottomMaxFour: calculatedPremiums.bottomMaxFour,
      topComfortCurr2: calculatedPremiums.topComfortCurr2,
      topExtraCurr2: calculatedPremiums.topExtraCurr2,
      topMaxCurr2: calculatedPremiums.topMaxCurr2,
      bottomComfortOneCurr2: calculatedPremiums.bottomComfortOneCurr2,
      bottomExtraOneCurr2: calculatedPremiums.bottomExtraOneCurr2,
      bottomMaxOneCurr2: calculatedPremiums.bottomMaxOneCurr2,
      bottomComfortTwoCurr2: calculatedPremiums.bottomComfortTwoCurr2,
      bottomExtraTwoCurr2: calculatedPremiums.bottomExtraTwoCurr2,
      bottomMaxTwoCurr2:calculatedPremiums.bottomMaxTwoCurr2,
      bottomComfortFourCurr2: calculatedPremiums.bottomComfortFourCurr2,
      bottomExtraFourCurr2: calculatedPremiums.bottomExtraFourCurr2,
      bottomMaxFourCurr2: calculatedPremiums.bottomMaxFourCurr2,
      glass: calculatedPremiums.glass,
      goLimit: calculatedPremiums.goLimit,
      selfParticipation: calculatedPremiums.selfParticipation,
      firstNameSaveOffer: currentFormData.saveOfferOwnerData.firstName,
      surNameSaveOffer: ' ',
      phoneSaveOffer:
        currentFormData?.saveOfferOwnerData?.countryCode +
        currentFormData?.saveOfferOwnerData?.phoneNumber,
      emailSaveOffer: currentFormData?.saveOfferOwnerData?.email,
      payerId: 0,
      chosenPackageId: selectedItem.packageId,
      selectedPayments: currentFormData?.selectedPayments || 1,
      block: currentFormData.block,
      streetNumber:currentFormData.streetNumber,
      longitude:  currentFormData.longitude,
      latitude:  currentFormData.latitude,
      placeId:  currentFormData.placeId,
      entrance: currentFormData.entrance,
      apartment: currentFormData.apartment,
      floor: currentFormData.floor,
      insuranceStartDate: currentFormData?.insuranceStart ? moment(currentFormData?.insuranceStart).format('DD.MM.yyyy') : null,
      propertyBoughtWithLoan: currentFormData?.isFinancedThroughLoan ? (currentFormData?.isFinancedThroughLoan == 'Y' ? true : false ) : null,
      propertyLoanBankName: currentFormData?.companyBeneficiaryData?.id,
      sameOwnerInsured: currentFormData?.samePerson ? (currentFormData?.samePerson == 'Y' ? true : false) : null,
      sameCorrespondenceAddress: currentFormData?.isPropertyAddressSameAsCorrespondence ? (currentFormData?.isPropertyAddressSameAsCorrespondence == 'Y' ? true : false ) : null,

      ownerFirstName: currentFormData?.samePerson == 'N' ? (currentFormData?.ownerData?.firstName ? currentFormData?.ownerData?.firstName: currentFormData?.ownerData?.companyName) : null ,
      ownerMiddleName: currentFormData?.samePerson == 'N' ? currentFormData?.ownerData?.middleName : null,
      ownerLastName: currentFormData?.samePerson == 'N' ? currentFormData?.ownerData?.lastName : null,
      ownerEgn: currentFormData?.samePerson == 'N' ? currentFormData.ownerData.egn : null,
      ownerEmail: currentFormData?.samePerson == 'N' ? currentFormData?.ownerData?.email : null,
      ownerMobilePrefix: currentFormData?.samePerson == 'N' ? currentFormData?.ownerData?.countryCode : null,
      ownerMobile: currentFormData?.samePerson == 'N' ? currentFormData?.ownerData?.phoneNumber : null,
      ownerPostCode: currentFormData?.samePerson == 'N' ? currentFormData?.ownerData?.postCode : null,
      ownerCity: currentFormData?.samePerson == 'N' ? currentFormData?.ownerData?.cityName : null,
      ownerAddress: currentFormData?.samePerson == 'N' ? currentFormData?.ownerData?.address : null,
      insuredFirstName: this.getInsurerDataSaveOffer()?.firstName,
      insuredMiddleName: this.getInsurerDataSaveOffer()?.middleName ,
      insuredLastName: this.getInsurerDataSaveOffer()?.lastName,
      insuredEgn:this.getInsurerDataSaveOffer()?.egn,
      insuredEmail: this.getInsurerDataSaveOffer()?.email,
      insuredMobilePrefix:  this.getInsurerDataSaveOffer()?.countryCode,
      insuredMobile: this.getInsurerDataSaveOffer()?.phoneNumber,
      insuredPostCode: this.getInsurerDataSaveOffer()?.postCode,
      insuredCity: this.getInsurerDataSaveOffer()?.cityName,
      insuredAddress: this.getInsurerDataSaveOffer()?.address,
      offerScreen: this.getCurrentScreenOffer(),
      agentId: currentFormData?.nIDAgent,
      emailCommunicationAgreement: currentFormData.agreement.agreement2==1 ? 'T' : 'F'
    };

    this.sharedService.loadingSpinner = true;
    if(this.savedOfferId){
      offerPayload['offerId'] = this.savedOfferId
    }
    this.http.post('/api/v1/offer/', offerPayload).subscribe((data: any) => {

      if(data?.offerId){
        this.savedOfferId = data?.offerId
        this.storage.set('offerId', data.offerId)
      }

      return this.http
        .post(
          '/api/v1/pdf/send-by-email/qb-offer?id=' + data.offerId,
          offerPayload,
          {
            responseType: 'text',
          }
        )
        .subscribe((result) => {
          this.sharedService.loadingSpinner = false;
          callback();
        });
    });
  }

  issuePolicy() {
    let currentFormData = this.formService.currentForm.getRawValue();

    let policyPayload = {
      propertyCategory: currentFormData.propertyCategory,
      propertySubcategory: currentFormData.propertySubcategory,
      postCode: currentFormData.postCode,
      area: currentFormData.area,
      currency: currentFormData.currency,
      city: currentFormData.cityName,
      cPurpose: currentFormData.purpose,
      yearOfConstruction: currentFormData.yearOfConstruction,
      numberOfFloors: 0,
      street: currentFormData.street,
      nIDagent: currentFormData.nIDAgent ? currentFormData.nIdAgentNumber : 345,
      beneficiaryId: currentFormData.companyBeneficiaryData
        ? currentFormData.companyBeneficiaryData.id
        : '0',
      country: 'BG',
      township: '',
      district: '',
      region: '',
      streetNumber: currentFormData.streetNumber,
      block: currentFormData.block,
      longitude:  currentFormData.longitude,
      latitude:  currentFormData.latitude,
      placeId:  currentFormData.placeId,
      blockName: '',
      entrance: currentFormData.entrance,
      floor: currentFormData.floor,
      apartment: currentFormData.apartment,
      cClaims: currentFormData.claimsExists,
      selectedPayments: currentFormData.selectedPayments || 1,
      selectedPackageId: currentFormData.selectedPackageId,
      insuranceStart: typeof(currentFormData.insuranceStart == 'string')? moment(currentFormData.insuranceStart).format('YYYY-MM-DD') :  currentFormData.insuranceStart.format('YYYY-MM-DD'),
      immovableinsuranceSum: currentFormData.immovableinsuranceSumRecommended,
      movableinsuranceSum: currentFormData.movableinsuranceSumRecommended,
      isEarthQuakeIncluded: currentFormData.isEarthQuakeIncluded,
      isGlassIncluded: currentFormData.isGlassIncluded,
      isGoMaxIncluded: currentFormData.isGoMaxIncluded,
      isDeductibleIncluded: currentFormData.isDeductibleIncluded,
      commissionDiscount: currentFormData.commissionDiscount,
      emailCommunicationAgreement: currentFormData.agreement.agreement2==1
        ? 'T'
        : 'F',
      cConfGenCond: currentFormData.agreement.agreement3 ? 'T' : 'F',
      ownerData: {
        nationalId: currentFormData.ownerData.egn,
        firstName: currentFormData.ownerData.firstName
          ? currentFormData.ownerData.firstName
          : currentFormData.ownerData.companyName,
        middleName: currentFormData.ownerData.middleName,
        lastName: currentFormData.ownerData.lastName,
        sCliType: currentFormData.ownerData.firstName ? 'PERSON' : 'COMPANY',
        countryCode: currentFormData.ownerData.countryCode,
        phoneNumber: this.formatPhoneNumberForPolicy(
          currentFormData.ownerData.phoneNumber
        ),
        email: currentFormData.ownerData.email,
        country: 'BG',
        postCode: currentFormData.ownerData.postCode,
        city: currentFormData.ownerData.cityName,
        sPermanentAddress: currentFormData.ownerData.address,
        sAgreeMarketing: true, //??
        sAgreeSensitiveData: 'T', //??
        sAgreeProcessing: 'F', //??
        sAgreeTransfOutsideEIP: 'F', //??
        sAgreeAutoProfile: 'F', //>>
      },
      insurerData: {
        nationalId: currentFormData.policyholderData.egn,
        firstName: currentFormData.policyholderData.firstName
          ? currentFormData.policyholderData.firstName
          : currentFormData.policyholderData.companyName,
        middleName: currentFormData.policyholderData.middleName,
        lastName: currentFormData.policyholderData.lastName,
        countryCode: currentFormData.policyholderData.countryCode,
        phoneNumber: this.formatPhoneNumberForPolicy(
          currentFormData.policyholderData.phoneNumber
        ),
        email: currentFormData.policyholderData.email,
        country: 'BG',
        postCode: currentFormData.policyholderData.postCode,
        city: currentFormData.policyholderData.cityName,
        sPermanentAddress: currentFormData.policyholderData.address,
        sAgreeMarketing: true, //??
        sAgreeSensitiveData: 'T', //??
        sAgreeProcessing: 'F', //??
        sAgreeTransfOutsideEIP: 'F', //??
        sAgreeAutoProfile: 'F', //>>
      },
    };

    this.sharedService.loadingSpinner = true;
    return this.http.post('/api/v1/policy/', policyPayload).pipe(
      tap(() => {
        if (this.sharedService.isOfferFromEmail) {
          this.sharedService
            .sendKpiTrackingData(KpiEnum.OFFER_TURNED_POLICY_COUNT)
            .subscribe();
        }
      }),
      tap((data) =>
        this.proposalService
          .trackingFinalData(data)
          .pipe(
            catchError((error) => {
              throw error;
            })
          )
          .subscribe()
      ),
      catchError((error) => {
        this.router.navigate(['somethingWentWrong']);
        return EMPTY;
      }),
      finalize(() => (this.sharedService.loadingSpinner = false))
    );
  }

  getPackageSum(calculatedPremiums, selectedItem, installments) {
    let payments = 'One';
    if (installments === 2) {
      payments = 'Two';
    }

    if (installments === 4) {
      payments = 'Four';
    }

    return calculatedPremiums[
      `bottom${selectedItem.packageRisks.packageName}${payments}`
    ];
  }

  private formatPhoneNumberForPolicy(phoneNumber) {
    return phoneNumber.replace('+359', '');
  }


  private getCurrentScreenOffer(){
    let url = window.location.pathname;
    if(url.includes('package-selection')) return 'OFFER';
    else if(url.includes('object-additional-details')) return 'FINAL_OPTIONS';
    else if(url.includes('contact-details-2')) return 'INSURER_FINAL_DETAILS';
    else if(url.includes('contact-details') || url.includes('companyOwnerFinalDetails') || url.includes('insurerData') ) return 'OWNER_FINAL_DETAILS';
    else if(url.includes('consents')) return 'AGREEMENTS';
    else if(url.includes('summary')) return 'CONFIRMATION';
  }

  private getInsurerDataSaveOffer(){
    let currentFormData = this.formService?.currentForm.getRawValue();
     if(currentFormData?.samePerson == 'Y')
       return currentFormData?.ownerData
     else {
       return currentFormData?.policyholderData
     }
   }

   deleteSavedOfferId(savedOfferId?){
    if(savedOfferId){
      return this.http.delete('/api/v1/review/offer?offerId=' + savedOfferId).subscribe()
    }
    else {
      if(this.localStorage.get('offerId')){
        let offerId = this.localStorage.get('offerId');
        localStorage.removeItem('offerId')
        return this.http.delete('/api/v1/review/offer?offerId=' + offerId).subscribe()
      }
    }




   }


}
